module.exports = __webpack_public_path__ + "static/media/additional-feedback.fe7a15be.svg";